import { Button } from '@/components/ui/button';
import { Wordmark } from '@/components/Wordmark';
import { useAuth } from '@/features/auth/AuthProvider';

/**
 * Holding screen for a signed-in account that is still awaiting admin
 * approval. The real gate is server-side (requireApproved); this is the UX
 * over it. The approval listener in the provider clears this live once an
 * admin approves — no sign-out needed.
 */
export function PendingApproval() {
  const { state, logout } = useAuth();
  const email = state.status === 'authenticated' ? state.current.user.email : null;
  return (
    <div className="mx-auto mt-10 max-w-md rounded-lg border border-[color:var(--color-border)] bg-card p-6 text-center shadow-sm sm:mt-20">
      <Wordmark className="mx-auto h-9 w-auto text-[color:var(--color-primary)]" />
      <h1 className="mt-5 text-lg font-bold" data-testid="pending-approval-title">
        Your account is awaiting approval
      </h1>
      <p className="mt-2 text-sm text-[color:var(--color-muted-fg)]">
        Thanks for signing up{email ? ` as ${email}` : ''}. An administrator needs to approve your
        access before you can use RHIA Flow. You’ll get in automatically once they do — no need to
        sign up again.
      </p>
      <Button
        type="button"
        variant="outline"
        className="mt-6"
        onClick={() => void logout()}
        data-testid="pending-approval-signout"
      >
        Sign out
      </Button>
    </div>
  );
}
